import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const domTrades: SeasonTrades[] = [
  {
    season: "2009/10",
    allTrades: [
      {
        otherTeam: manager.nissim,
        sentAway: "Marcus Thornton",
        gotInReturn: "Jason Kidd",
      },
    ],
  },
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.chauncey,
        sentAway: "Steve Nash",
        gotInReturn: "Ty Lawson",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Zach Randolph",
        gotInReturn: "Klay Thompson",
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Russell Westbrook and Paul Millsap",
        gotInReturn: "Eric Bledsoe and Chris Bosh",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Ty Lawson, Nikola Pekovic and Spencer Hawes",
        gotInReturn: "Serge Ibaka and Carlos Boozer",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Carlos Boozer",
        gotInReturn: "Brandon Jennings",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Serge Ibaka and Brandon Jennings",
        gotInReturn: "Michael Carter-Williams and Jameer Nelson",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Goran Dragic and Kenneth Faried",
        gotInReturn: "Jonas Valanciunas and Reggie Jackson",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Kawhi Leonard",
        gotInReturn: "Dwyane Wade",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Kevin Martin",
        gotInReturn: "Andrew Bogut and Roy Hibbert",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Gordon Hayward and Nikola Pekovic",
        gotInReturn: "Hassan Whiteside and Mike Conley",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Michael Carter-Williams",
        gotInReturn: "Goran Dragic and Brandon Knight",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Klay Thompson",
        gotInReturn: "Rodney Hood, DeMar DeRozan and Rajon Rondo",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Ish Smith and Jerami Grant",
        gotInReturn: "Pau Gasol and Mirza Teletovic",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Aaron Gordon",
        gotInReturn: "LaMarcus Aldridge and Bradley Beal",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Dwight Howard",
        gotInReturn: "Serge Ibaka",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Caris LeVert",
        gotInReturn: "Gordon Hayward",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Paul Millsap and Rodney Hood",
        gotInReturn: "Dennis Schroder and Lauri Markkanen",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Taj Gibson",
        gotInReturn: "Nikola Vucevic",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Derrick Favors",
        gotInReturn: "Taurean Prince",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Jayson Tatum",
        gotInReturn: "Aaron Gordon",
        amongWorstTrades: true,
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Deandre Ayton, Paul Millsap and Dario Saric",
        gotInReturn: "Luka Doncic and Trae Young",
        amongBestTrades: true,
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Jimmy Butler",
        gotInReturn: "Paul George",
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Lonzo Ball and DeMar DeRozan",
        gotInReturn: "John Collins",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.mati,
        sentAway: "TJ Warren",
        gotInReturn: "Victor Oladipo and Jaylen Brown",
      },
    ],
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.nissim,
        sentAway: "Luka Doncic",
        gotInReturn: "James Harden and Jae'Sean Tate",
        amongWorstTrades: true,
      },
    ],
  },
  { season: "2021/22", allTrades: [] },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "John Collins",
        gotInReturn: "Dejounte Murray",
      },
    ],
  },
  {
    season: "2023/24",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Myles Turner",
        gotInReturn: "Lauri Markkanen",
        amongBestTrades: true,
      },
    ],
  },
  {
    season: "2024/25",
    allTrades: [
      {
        otherTeam: manager.shahar,
        sentAway: "Lauri Markkanen and Benedict Mathurin",
        gotInReturn: "Dereck Lively"
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Yves Missi",
        gotInReturn: "Andre Drummond"
      },
      {
        otherTeam: manager.idan,
        sentAway: "Brandon Miller",
        gotInReturn: "Donovan Mitchell and Gradey Dick"
      },
    ]
  }
];
